import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/app/layouts/default.vue").then(m => m.default || m))
}